(async () => {
  if (!customElements.get('product-pair-with')) {
    class ProductPairWith extends HTMLElement {
      constructor() {
        super();

        this.cartDrawer = document.querySelector('cart-drawer');
        
        this.querySelectorAll('[data-toggle-me]').forEach((toggle) => {
          toggle.addEventListener('click', this.toggleSelector.bind(this));
        });

        this.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
          variant.addEventListener('click', this.toggleVariant.bind(this));
        });

        this.querySelectorAll('[data-add-button]').forEach((add) => {
          add.addEventListener('click', this.addProduct.bind(this));
        });

      }

      addProduct(event) {

        let id = '';
        let itemId = '';

        if (event.target.closest('[data-add-button]')) {
          event.target.closest('[data-add-button]').classList.add('loading');
          if (event.target.closest('[data-add-button]').dataset && event.target.closest('[data-add-button]').dataset.productId) {
            id = event.target.closest('[data-add-button]').dataset.productId;
          } else {
            id = event.target.closest('[data-total-bundle]').querySelector('[data-bundle-variant-group] .border-black').dataset.bundleVariantId;
          }
          itemId = event.target.closest('[data-add-button]').dataset.discountProduct;
        } else {
          if (event.target.dataset && event.target.dataset.productId) {
            id = event.target.dataset.productId;
          } else {
            id = event.target.closest('[data-total-bundle]').querySelector('[data-bundle-variant-group] .border-black').dataset.bundleVariantId;
          }
          itemId = event.target.dataset.discountProduct;
        }

        let items = [];
        let properties = {};
        properties._promo_product = 'false';
        properties._funnel = 'PDP';
        properties._funnel_location = 'pair_with';
        properties._funnel_type = 'manual';
        properties._promo = false;

        // validate regular discounts
        applyDiscounts();

        let object = {};
        object = {
          quantity: 1,
          id: parseInt(id),
          properties
        }
        items.push(object);

        let body = JSON.stringify({
          items: items,
          sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {

            localStorage.removeItem('refused_gifts');

            if (this.cartDrawer) {
              this.cartDrawer.renderContents(parsedState);
            }
            this.cartDrawer.open();

            event.target.closest('[data-add-button]').classList.remove('loading');

            window.igEvents = window.igEvents || [];
            window.igEvents.push({
              "event": "ATC - Pair with"
            })
          })
          .catch((e) => {
            console.error(e);
          })
      }

      toggleVariant(event) {
        event.preventDefault();
        event.stopPropagation();
        let parent = event.target.closest('[data-total-bundle]');
        let img = event.target.src;
        let name = '';
        parent.querySelector('[data-bundle-variant-group] .border-black').classList.remove('border-black');
        if (event.target.dataset && event.target.dataset.bundleVariantId) {
          img = event.target.querySelector('img').src;
          name = event.target.dataset.bundleVariantColor;
          event.target.classList.add('border-black');
          event.target.classList.remove('border-black-50');
        } else {
          name = event.target.closest('[data-bundle-variant]').dataset.bundleVariantColor;
          event.target.closest('[data-bundle-variant]').classList.add('border-black');
          event.target.closest('[data-bundle-variant]').classList.remove('border-black-50');
        }
        parent.querySelector('[data-current-bundle-variant] img').src = img;
        parent.querySelector('[data-current-bundle-variant] img').srcset = img;
        parent.querySelector('[data-current-bundle-variant] span').innerHTML = name;
      }

      toggleSelector(event) {
        event.preventDefault();
        event.stopPropagation();
        event.target.closest('[data-total-bundle]').classList.toggle('active');
        event.target.closest('product-pair-with').classList.toggle('active');
      }

    }

    window.ProductPairWith = ProductPairWith;
    customElements.define('product-pair-with', ProductPairWith);
  }
})();
